// USerAPI.js

import { $authHost, $host } from "./index";


export const login = async (email, password) => {
    try {
        const { data } = await $host.post(`/api/auth/login`, { email, password }, { withCredentials: true });
        console.log("Ответ сервера:", data);
        localStorage.setItem('user', JSON.stringify(data.user));
        return data;
    } catch (error) {
        console.error("Ошибка авторизации:", error.response?.data || error.message);
        throw error;
    }
}


export const verifyCode = async (email, code) => {

    const response = await $host.post(`api/auth/verify-code`, {
        email: email,
        code: code,
    })
    console.log(response);
    return response
}

export const register = async (info) => {
    try {
        const formData = new FormData();
        formData.append('email', info.email);
        formData.append('password', info.password);
        const response = await $host.post(`/api/auth/register`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',  // Важный заголовок
            },
        });
        // Сохранение данных пользователя в localStorage
        const userData = response.data; // Предполагаем, что все данные пользователя находятся здесь
        localStorage.setItem('user', JSON.stringify(userData));
        console.log('Ответ от сервера:', response);
        return response.data;
    } catch (error) {
        if (error.response) {
            console.error('Ошибка с сервера:', error.response.data.error);
            throw new Error(error.response.data.error || "Ошибка");
        } else if (error.request) {
            console.error('Ошибка сети или ответа нет:', error.request);
            throw new Error("Ошибка сети. Сервер не отвечает.");
        } else {
            console.error('Произошла ошибка:', error.message);
            throw new Error("Произошла ошибка при отправке данных.");
        }
    }
};
export const updateUser = async (info) => {
    try {
        const formData = new FormData();
        if (info.first_name) {
            formData.append('first_name', info.first_name);
        }
        if (info.last_name) {
            formData.append('last_name', info.last_name);
        }
        if (info.avatar) {
            formData.append('avatar', info.avatar);
        }
        if (info.email) {
            formData.append('email', info.email);
        }
        const response = await $host.post(`/api/students/users/update`, formData, {
            withCredentials: true,
            headers: {
                'Content-Type': 'multipart/form-data',  // Важный заголовок
            },
        });
        // Сохранение данных пользователя в localStorage
        const userData = response.data; // Предполагаем, что все данные пользователя находятся здесь
        localStorage.setItem('user', JSON.stringify(userData));
        console.log('Ответ от сервера:', response);
        return response.data;
    } catch (error) {
        if (error.response) {
            console.error('Ошибка с сервера:', error.response.data.error);
            throw new Error(error.response.data.error || "Ошибка");
        } else if (error.request) {
            console.error('Ошибка сети или ответа нет:', error.request);
            throw new Error("Ошибка сети. Сервер не отвечает.");
        } else {
            console.error('Произошла ошибка:', error.message);
            throw new Error("Произошла ошибка при отправке данных.");
        }
    }
};

export const logout = async (user, navigate, aiChat, chat) => {
    if (!user) {
        console.error("❌ Ошибка: `user` не передан в `logout()`");
        return null;
    }

    try {
        const response = await $host.post(`/api/auth/logout`, {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
        });

        console.log("🔄 Logout response:", response);

        if (!response || !response.status) {
            console.error("❌ Ошибка: сервер не вернул статус ответа");
            return null;
        }

        if (response.status === 200) {
            console.log("✅ Пользователь успешно вышел");

            // 🚀 **Полностью очищаем данные пользователя**
            user.clearUserData();

            // 🗑 **Чистим localStorage и куки**
            localStorage.removeItem("user");
            document.cookie = "access_token=; Max-Age=0; path=/";

            // 🛑 **Закрываем чаты**
            aiChat?.close();
            chat?.closeAll();

            // 🔄 **Перенаправляем на страницу входа**
            navigate("/");

            return response;
        } else {
            console.error("❌ Ошибка при выходе:", response);
            return null;
        }
    } catch (error) {
        console.error("❌ Ошибка при выходе:", error);
        return null;
    }
};




export const refreshExpiredToken = async () => new Promise(resolve => setTimeout(resolve, 1000));


export const tgInit = async (userData) => {
    if (!userData.id || !userData.hash) {
        console.warn("❌ Получены неполные данные, авторизация не выполнена.");
        return null;
    }

    try {
        const response = await $host.post("/api/auth/telegram/callback", userData, {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
        });

        console.log("🔄 Ответ от сервера:", response);

        // ✅ Явно забираем `data`
        const data = response?.data;

        if (!data || typeof data !== "object") {
            console.error("❌ Ошибка: сервер вернул пустой или невалидный JSON!", response);
            return null;
        }

        console.log("✅ JSON-данные от сервера:", data);

        if (!data.status || !data.user) {
            console.error("❌ Ошибка: В ответе нет `status` или `user`!", data);
            return null;
        }

        console.log("✅ Telegram-авторизация успешна:", data);
        return data; // ✅ Возвращаем `data`, а не `null`
    } catch (error) {
        console.error("❌ Ошибка авторизации через Telegram:", error.response?.data || error.message);
        return null;
    }
};



export const resetPasswordRequest = async (email) => {
    const response = await $host.post(`/api/auth/request-password-reset`, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
        email: email
    })
    console.log(response);
    return response
}

export const verifyResetCode = async (code, email) => {
    const response = await $host.post(`/api/auth/verify-reset-code`, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
        code: code,
        email: email,
    })
    console.log(response);
    return response
}

export const resetPassword = async (code, email, new_password) => {
    const response = await $host.post(`/api/auth/reset-password`, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
        code: code,
        email: email,
        new_password: new_password
    })
    console.log(response);
    return response
}

export const resendVerificationCode = async (email) => {
    try {
        const response = await $host.post(`/api/auth/resend-verification-code`, { email }, {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
        });

        console.log("🔄 Код повторно отправлен:", response.data);
        return response.data;
    } catch (error) {
        console.error("❌ Ошибка при отправке нового кода:", error.response?.data || error.message);
        throw error;
    }
};
